import type {Comment} from './api';
import type {ChatVisit} from './chat-visit';
export type Message = Comment & {kind: 'chat' | 'position'};
export type MessageFilter = 'all' | 'position' | 'open';
export interface Position {projectSec: number; label: string}
export interface Draft {text: string; position?: Position}
export function mergeMessages(chat: Comment[], positions: Comment[]): Message[] {
  const byId = new Map<string, Message>();
  for (const message of chat) byId.set(message.id, {...message, kind:'chat'});
  for (const message of positions) byId.set(message.id, {...message, kind:'position'});
  return [...byId.values()].sort((a,b) => a.ts-b.ts || a.id.localeCompare(b.id));
}
export function selectMessages(messages: Message[], visit: ChatVisit, filter: MessageFilter, expanded: boolean) {
  const groups = visit.split(messages.filter(m => m.kind === 'chat'));
  const archived = new Set(groups.archive.map(m => m.id));
  return {
    archiveCount: groups.archive.length,
    visible: messages.filter(m => filter === 'position' ? m.kind === 'position'
      : filter === 'open' ? m.kind === 'position' && !m.resolved
      : m.kind === 'position' || expanded || !archived.has(m.id)),
  };
}
/** Copy the anchor now: sending later must never consult the live playhead. */
export function capturePosition(position: Position): Position | undefined {
  return Number.isFinite(position.projectSec) ? {...position} : undefined;
}
